import { useState } from 'react';
import { useIntl } from 'react-intl';

import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { RoutingTable } from '~/features/workflow-routing/RoutingTable';

const Page = () => {
  const intl = useIntl();
  const [showCreatePanel, setShowCreatePanel] = useState(false);

  const pageActions = [
    {
      icon: 'plus' as const,
      level: 'primary' as const,
      text: intl.formatMessage({
        id: 'RoutingTable.createNewRoute',
        defaultMessage: 'Create New Route',
        description: 'Button text for creating new route',
      }),
      onClick: () => {
        setShowCreatePanel(true);
      },
    },
  ];

  return (
    <PageLayout
      actions={pageActions}
      title={intl.formatMessage({
        id: 'RoutingTable.pageTitle',
        defaultMessage: 'Routing Table',
        description: 'Page title for routing table',
      })}
    >
      <RoutingTable
        showCreatePanel={showCreatePanel}
        onCreatePanelClose={() => setShowCreatePanel(false)}
      />
    </PageLayout>
  );
};

export default Page;
